import { useEffect } from 'react';
import { CategoryIds } from '~/components/Account/Profile/util/tileEnums';
import { analyticsTrackEvent } from '~/core/analytics';
import { ACTION_SEE_SWIMLANE, DRAWER_TYPES, PROFILE_DISCOVER } from '~/core/analytics/events';

/**
 * Tracks a user seeing a nav tile
 */
export function useTrackNavTile(drawerType: typeof DRAWER_TYPES[number]) {
  useEffect(() => {
    analyticsTrackEvent(PROFILE_DISCOVER, {
      action: ACTION_SEE_SWIMLANE,
      categoryId: CategoryIds.GET_STARTED,
      drawerType,
    });
  }, [drawerType]);
}
